export enum ToolbarOptions {
    Initialize_Project = "Initialize Projects",
    Edit_Project_Areas = "Edit Project Areas",
    Submit_Flightplans = "Submit Flightplans",
    Edit_Flightplans = "Edit Flightplans",
    Submit_Mission_Logs = "Submit Mission Logs",
    Edit_Mission_Logs = "Edit Mission Logs",
    Edit_Lookup_Tables = "Edit Lookup Tables",
    Edit_Blog_Entries = "Edit Blog Entries",
    Mission_Admin = "Mission Admin",
    Flightline_QC_Review = "Flightline QC Review",
}

export type PermissionsType = {
    [ToolbarOptions.Initialize_Project]?: boolean
    [ToolbarOptions.Edit_Project_Areas]?: boolean
    [ToolbarOptions.Submit_Flightplans]?: boolean
    [ToolbarOptions.Edit_Flightplans]?: boolean
    [ToolbarOptions.Submit_Mission_Logs]?: boolean
    [ToolbarOptions.Edit_Mission_Logs]?: boolean
    [ToolbarOptions.Edit_Lookup_Tables]?: boolean
    [ToolbarOptions.Edit_Blog_Entries]?: boolean
    [ToolbarOptions.Mission_Admin]?: boolean
    [ToolbarOptions.Flightline_QC_Review]?: boolean
}

export type ToolbarOptionType = {
    name: string
    enabled: boolean
    suboptions: ToolbarOptionType[]
}
